const isProduction = process.env.NODE_ENV === 'production'

if (isProduction && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const baseUrl = process.env.BASE_URL || '/'
    navigator.serviceWorker.register(`${baseUrl}service-worker.js`).catch(() => {
      // PWA installation should not block normal app usage.
    })
  })
}
